import faviconTiT from '../assets/images/favicon.ico';
import { TALENT2TEST, TALENTIT, TEAM4TALENT, CYBERTALENT, TALENT4INSIGHT } from '../constants/companies';

class MultibrandingService {
  applyBranding(company) {
    document.title = `My${company}`;

    switch (company) {
      case TALENTIT:
        import('../assets/css/branding/talentit.css');
        replaceFavicon(faviconTiT);
        return '#ff5500';
      case TALENT4INSIGHT:
        import('../assets/css/branding/talentit.css');
        replaceFavicon(faviconTiT);
        return '#ff5500';
      case TALENT2TEST:
        import('../assets/css/branding/talent2test.css');
        replaceFavicon(faviconTiT);
        return '#58B0E3';
      case CYBERTALENT:
        import('../assets/css/branding/cybertalent.css');
        replaceFavicon(faviconTiT);
        return '#5100DF';
      case TEAM4TALENT:
      default:
        import('../assets/css/branding/team4talent.css');
        replaceFavicon(faviconTiT);
        return '#0ad8b7';
    }
  }
}

function replaceFavicon(src) {
  const linkTag = document.createElement('link');
  linkTag.rel = 'shortcut icon';
  linkTag.href = src;

  document.getElementsByTagName('head')[0].appendChild(linkTag);
}

export default new MultibrandingService();
